export default __webpack_public_path__ + "static/media/Background 5_00032.7ca3f60a.png";